<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <path fill="url(#bg_inquiries)" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"/>
  <path stroke="url(#border_inquiries)" stroke-width=".5" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"/>
  <g stroke="#FFBA42" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5">
    <path d="M26 31C26 27.686 28.686 25 32 25H48C51.314 25 54 27.686 54 31V41C54 44.314 51.314 47 48 47H38L32 53V47H32C28.686 47 26 44.314 26 41V31Z"/>
    <path d="M37.5 33.5C37.5 32.119 38.619 31 40 31C41.381 31 42.5 32.119 42.5 33.5C42.5 34.881 40 35.8 40 37.2"/>
    <circle cx="40" cy="41.5" r="0.75" fill="#FFBA42" stroke="none"/>
  </g>
  <defs>
    <linearGradient id="bg_inquiries" x1="83.625" x2="21.485" y1="80.021" y2="-20.52" gradientUnits="userSpaceOnUse">
      <stop stop-color="#13142B"/>
      <stop offset="1" stop-color="#050621"/>
    </linearGradient>
    <linearGradient id="border_inquiries" x1="40" x2="40" y1="0" y2="80" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA100"/>
      <stop offset="1" stop-color="#996100" stop-opacity=".5"/>
    </linearGradient>
  </defs>
</svg>
